<div class="wrapper">
  <div class="info">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
            clip-rule="evenodd"/>
    </svg>
    <p>Press comma, enter or tab to add the entry below.</p>
  </div>
  <input type="text" #input autocomplete="off" (keyup)="keyup($event)" (keydown)="keydown($event)"
         [placeholder]="(values.length > 0)? 'Add another tag': 'Add a tag'">
  <div class="values" *ngIf="values.length > 0">
    <span *ngFor="let value of values">
      {{value}}
      <svg (click)="remove(value)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
      </svg>
    </span>
  </div>
</div>
